module.exports = __webpack_public_path__ + "img/three1Red.be3c8922.jpg";